import { InjectionToken } from '@angular/core';

export const BODY_REPORT_DAMAGE_DATA = new InjectionToken<any>('BODY_REPORT_DAMAGE_DATA');
